import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { GenerateAiIconRootParamList } from "../../../../types";
import { GenerateIconScreen } from "./GenerateIconScreen";
import { GenerateAiIconForm } from "../../../../components/GenerateAiIconForm";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { PreviewIconScreen } from "./PreviewIconScreen";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { PickIconThemeScreen } from "./PickIconThemeScreen";

type ScreenParams = {
  GenerateAiIconRootScreen: {
    description?: string;
  };
};

export type GenerateAiIconRootScreenProps = NativeStackScreenProps<
  ScreenParams,
  "GenerateAiIconRootScreen"
>;

export const GenerateAiIconRootScreen = ({
  route,
}: GenerateAiIconRootScreenProps) => {
  const Stack = createStackHeaderNavigator<GenerateAiIconRootParamList>();
  const { description } = route.params;

  return (
    <GenerateAiIconForm defaultFormValues={{ description: description || "" }}>
      <Stack.Navigator>
        <Stack.Group
          screenOptions={{
            headerShown: true,
            headerLeft: () => <ModalCloseButton type="Cancel" />,
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            title: "",
          }}
        >
          <Stack.Screen
            name="GenerateIconScreen"
            component={GenerateIconScreen}
          />
          <Stack.Screen
            name="PreviewIconScreen"
            component={PreviewIconScreen}
            options={{ headerLeft: () => <ModalCloseButton type="Back" /> }}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{
            headerShown: true,
            presentation: "modal",
            animationEnabled: true,
            headerLeft: () => <ModalCloseButton type="Cancel" />,
            cardStyleInterpolator:
              CardStyleInterpolators.forModalPresentationIOS,
            title: "",
          }}
        >
          <Stack.Screen
            name="PickIconThemeScreen"
            component={PickIconThemeScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </GenerateAiIconForm>
  );
};
